module.exports = __webpack_public_path__ + "img/questions.3ccac64f.svg";